var _bucketToIconMap;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import Search from '../Icons/Search';
import Eye from '../Icons/Eye';
import Currency from '../Icons/Currency';
import { RESEARCHERS, BROWSERS, BUYERS, BUCKETS } from './constants';
import FeaturedIcon from '../FeaturedIcon';
import { Icon as IconBase } from '../FeaturedIcon/styles';
var bucketToIconMap = (_bucketToIconMap = {}, _defineProperty(_bucketToIconMap, RESEARCHERS, IconBase.withComponent(Search)), _defineProperty(_bucketToIconMap, BROWSERS, IconBase.withComponent(Eye)), _defineProperty(_bucketToIconMap, BUYERS, IconBase.withComponent(Currency)), _bucketToIconMap);
export default function ShopperBucketIcon(_ref) {
  var bucket = _ref.bucket,
      rest = _objectWithoutProperties(_ref, ["bucket"]);

  return /*#__PURE__*/React.createElement(FeaturedIcon, Object.assign({
    Icon: bucketToIconMap[bucket]
  }, rest));
}
ShopperBucketIcon.propTypes = {
  bucket: PropTypes.oneOf(BUCKETS).isRequired
};